export const Razorpay = {
  keyId: process.env.REACT_APP_RAZORPAY_KEY_ID
};
